import * as types from './mutation-types';

export default {
  [types.SET_ALERTS](state, alerts) {
    state.alerts = alerts;
  },
};
